import React from 'react'
import './marker.less'
interface Props {
  suffix: string
}
export const CornerMarker: React.FC<Props> = ({suffix}) => {
  const getColor = () => {
    switch (suffix) {
      case 'pdf':
        return {
          type: 'pdf',
          color: '#ff4d4f',
        }

      case 'ppt':
      case 'pptx':
        return {
          type: 'ppt',
          color: '#ffa400',
        }
      case 'doc':
      case 'docx':
        return {type: 'word', color: '#2adea0'}
      case 'jpg':
      case 'jpeg':
        return {
          type: 'img',
          color: '#0f921c',
        }
      case 'mp4':
        return {
          type: 'video',
          color: '#048edc',
        }

      default:
        return {
          type: 'other',
          color: '#adadae',
        }
    }
  }

  return (
    <>
      <div className="corner-marker" style={{backgroundColor: `${getColor().color}`}}>
        {getColor().type}
      </div>
    </>
  )
}
